export default {
  NOT_ANSWERED: 'not_answered',
  CORRECT: 'correct',
  WRONG: 'wrong',
};
